import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
// @ts-ignore
import shipImg from '../../../../../assets/coverpages/ship.png';
import { marpolSelectors } from '../../../../../redux/app/marpol';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';
import { commonUtils } from 'redux/_common';

type OwnProps = {
    children: React.ReactNode;
	vesselId: string;
};
type BallastCoverPageProps = PropsFromRedux & OwnProps;
function BallastCoverPage(props: BallastCoverPageProps) {
    const { vesselInfo, children, dateRange, ballastData } = props;

    return (
        <>
            {/* First Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2">
                <div className="mx-0 my-24 text-xl font-bold text-center">
                    <h3 className="uppercase border-2 border-gray-900 p-8 mb-4">
                        Ballast Water Record Book
                    </h3>
                    <hr className="border-gray-900 border-2" />
                </div>
                <div className="w-full font-bold">
                    <div className="w-full">
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350, fontSize: 18 }}
                        >
                            <span style={{ minWidth: 180 }}>Name of Ship:</span>
                            <span
                                className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                style={{ minHeight: 18 }}
                            >
                                {vesselInfo?.vesselName}{' '}
                            </span>
                        </p>
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350, fontSize: 18 }}
                        >
                            <span style={{ minWidth: 180 }}>
                                IMO number, distinctive number or letters:
                            </span>
                            <span
                                className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                style={{ minHeight: 18 }}
                            >
                                {vesselInfo?.imoNumber}{' '}
                            </span>
                        </p>
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350, fontSize: 18 }}
                        >
                            <span style={{ minWidth: 180 }}>
                                Gross Tonnage:
                            </span>
                            <span
                                className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                style={{ minHeight: 18 }}
                            >
                                {vesselInfo?.tonnage?.grossTonnage}{' '}
                            </span>
                        </p>
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350, fontSize: 18 }}
                        >
                            <span style={{ minWidth: 70 }}>Flag:</span>
                            <span
                                className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                style={{ minHeight: 18 }}
                            >
                                {vesselInfo?.flag}{' '}
                            </span>
                        </p>
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350, fontSize: 18 }}
                        >
                            <span style={{ minWidth: 400 }}>
                                Total Ballast Water capacity (in cubic metres):
                            </span>
                            <span
                                className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                style={{ minHeight: 18 }}
                            >
                                {ballastData?.totalBallastWaterCapacity}{' '}
                            </span>
                        </p>
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350, fontSize: 18 }}
                        >
                            <span style={{ minWidth: 580 }}>
                                Number of the International Ballast Water
                                Management Certificate:
                            </span>
                            <span
                                className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                style={{ minHeight: 18 }}
                            >
                                {ballastData?.certificateNo}{' '}
                            </span>
                        </p>
                        <p
                            className="p-0.5 m-0.5 flex items-center gap-4"
                            style={{ minWidth: 350, fontSize: 18 }}
                        >
                            <span style={{ minWidth: 220 }}>Period:</span>
                            <span className="flex w-full items-center">
                                <span className="flex w-full items-center">
                                    From
                                    <span
                                        className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                        style={{ minHeight: 18 }}
                                    >
                                        {moment(
                                            props.dateRange?.startDate
                                        ).format('DD-MMM-YY')}{' '}
                                    </span>
                                </span>
                                <span className="flex w-full items-center">
                                    To
                                    <span
                                        className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                        style={{ minHeight: 18 }}
                                    >
                                        {moment(
                                            props.dateRange?.endDate
                                        ).format('DD-MMM-YY')}{' '}
                                    </span>
                                </span>
                            </span>
                        </p>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full">
                                English
                            </p>
                        </div>
                    </div>
                </div>
                <div className="font-bold mt-48">
                    <p>
                        BALLAST WATER RECORD BOOK - INTERNATIONAL CONVENTION FOR
                        THE CONTROL AND MANAGEMENT OF SHIPSʹ BALLAST WATER AND
                        SEDIMENTS
                    </p>
                </div>
            </div>
            {/* Second Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="text-justify mb-8 text-lg">
                    <h4 className="text-center font-bold mb-4">NOTICE</h4>
                    <p className="mb-4">
                        Together with the enclosed instructions, this is the
                        Official Ballast Water Record Book of the Maritime
                        Administrator.
                    </p>
                    <p>
                        This Book has been designed so that it may be used by
                        ALL ships for recording ballast water operations.
                    </p>
                </div>
                {/* <div className='mt-8 text-justify italic text-lg'>
                    <p>
                        The within document is published by the Liberian Maritime Registry, by the
                        authority of the Liberian Government, granted by the Republic of Liberia, Liberia
                        Maritime Authority. It is an official publication of the Liberian Registry. Its
                        contents and the Republic of Liberia logo and seal may not be copied, reproduced
                        or distributed without prior permission in writing from the Liberian Registry.
                    </p>
                    <p className='font-bold'>Copyright © All rights reserved.</p>
                </div> */}
            </div>
            {/* Third Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="flex mx-0 mb-16 text-xl font-bold text-center">
                    <div className="flex items-center justify-center border-2 border-gray-900 w-3/4">
                        <h3 className="uppercase p-8 mb-4 text-center">
                            BALLAST WATER RECORD BOOK INSTRUCTIONS
                        </h3>
                    </div>
                    <div className="flex items-center justify-center border-2 border-gray-900 border-l-0 w-1/4">
                        {/* <h3 className="uppercase p-8 mb-4 text-center">LIBERIA MARITIME AUTHORITY</h3> */}
                    </div>
                </div>
                <div className="mb-8">
                    <h4 className="text-center font-bold mb-4 text-lg">
                        INTRODUCTION
                    </h4>
                    <ol className="ml-4 list-decimal marker:font-bold">
                        <li className="mb-8">
                            <b>Introduction</b>
                            <p>
                                In accordance with regulation B-2 of the annex
                                to the International Convention for the Control
                                and Management of Ship’s Ballast Water and
                                Sediments, a record is to be kept of each
                                ballast water operation. This includes
                                discharges at sea and to reception facilities.
                            </p>
                        </li>
                        <li className="mb-8">
                            <b>Ballast Water and Ballast Water Management</b>
                            <p>
                                “Ballast Water” means water with its suspended
                                matter taken on board a ship to control trim,
                                list, draught, stability, or stresses of a ship.
                                Management of Ballast Water shall be in
                                accordance with an approved Ballast Water
                                Management Plan and taking into account
                                Guidelines<sup>1</sup> developed by the
                                International Maritime Organization (the
                                Organization).
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Entries in the Ballast Water Record Book shall
                                be made on the occasions listed on pages{' '}
                                <strong>13-15</strong>.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                The Ballast Water Record Book must be available
                                at all times for examination by officers duly
                                authorized by a Party to the Convention on board
                                any ship to which the regulation B-2 applies
                                while the ship is in a port or offshore terminal
                                under the jurisdiction of that State Party.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                The Ballast Water Record Book entries shall be
                                maintained on board the ship for a minimum
                                period of two (2) years after the last entry has
                                been made and thereafter in the Company’s
                                control for a minimum period of three (3) years.
                                (regulation B-2.2)
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                The Ballast Water Record Book shall be kept
                                readily available for inspection at all
                                reasonable times and, in the case of an unmanned
                                ship under tow, may be kept on the towing ship.
                                (regulation B-2.4)
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                The Ballast Water Record Book must be properly
                                completed. All Ballast Water operations must be
                                clearly and accurately recorded. See the sample
                                entries in the Ballast Water Record Book.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Owners and their Legal Advisors, Masters and
                                Officers are reminded that, in addition to
                                regulations concerning maintenance of a Ballast
                                Water Record Book, this record is a valuable
                                means of providing evidence that the ship has
                                complied with Ballast Water regulations.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Officers duly authorized by a Party to the
                                Convention may inspect the Ballast Water Record
                                Book on board any ship to which regulation B-2
                                applies while the ship is in its port or
                                offshore terminals and may make a copy of any
                                entry and may require the Master of the ship to
                                certify that the copy is a true copy. Any copy
                                so certified shall be admissible in any judicial
                                proceedings as evidence of the facts stated in
                                the entry. The inspection of a Ballast Water
                                Record Book and the taking of a certified copy
                                shall be performed as expeditiously as possible
                                without causing the ship to be unduly delayed.
                                (regulation B-2.6)
                            </p>
                        </li>
                    </ol>
                </div>
                <div
                    className="border-[#2D3748] border-[0.5px] mt-32 mb-3 mx-0"
                    style={{ width: 224 }}
                />
                <div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">1</sup>
                        <span className="text-sm">
                            Refer to the Guidelines for Ballast Water Management
                            and Development of Ballast Water Management Plans
                            adopted by the Organization by resolution
                            MEPC.127(53), as amended.
                        </span>
                    </div>
                </div>
            </div>
            {/* Fourth Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="mb-8">
                    <h4 className="font-bold mb-4">
                        Excerpts from the International Convention for the
                        Control and Management of Ship’s Ballast Water and
                        Sediments
                    </h4>
                    <p className="font-bold mb-4">
                        <b>Regulation B-2 - Ballast Water Record Book</b>
                    </p>
                    <ol className="ml-4 list-decimal marker:font-bold">
                        <li className="mb-8">
                            <p>
                                Each ship shall have on board a Ballast Water
                                Record Book, that may be an electronic record
                                book, or that may be integrated into another
                                record book or system, and which shall at least
                                contain the information specified in appendix
                                II. Electronic record books shall be approved by
                                the Administration taking into account the
                                guidelines developed by the Organization.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Ballast Water record book entries shall be
                                maintained on board the ship for a minimum
                                period of two years after the last entry has
                                been made and thereafter in the Company’s
                                control for a minimum period of three years.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                In the event of the discharge of Ballast Water
                                pursuant to regulations A-3, A-4 or B-3.6 or in
                                the event of other accidental or exceptional
                                discharge of Ballast Water not otherwise
                                exempted by this Convention, an entry shall be
                                made in the Ballast Water record book describing
                                the circumstances of, and the reason for, the
                                discharge.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                The Ballast Water record book shall be kept
                                readily available for inspection at all
                                reasonable times and, in the case of an unmanned
                                ship under tow, may be kept on the towing ship.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Each operation concerning ballast water shall be
                                fully recorded without delay in the Ballast
                                Water Record Book. Each entry shall be signed by
                                the officer in charge of the operation concerned
                                and each completed page shall be signed by the
                                master or, in the case of a group of electronic
                                entries, shall be verified by the master in a
                                timely manner. The entries in the Ballast Water
                                Record Book shall be in the working language of
                                the ship. If that language is not English,
                                French or Spanish, the entries shall contain a
                                translation into one of those languages. When
                                entries in an official national language of the
                                State whose flag the ship is entitled to fly are
                                also used, these shall prevail in case of a
                                dispute or discrepancy.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Officers duly authorized by a Party may inspect
                                the Ballast Water record book on board any ship
                                to which this regulation applies while the ship
                                is in its port or offshore terminal, and may
                                make a copy of any entry, and require the master
                                to certify that the copy is a true copy. Any
                                copy so certified shall be admissible in any
                                judicial proceeding as evidence of the facts
                                stated in the entry. The inspection of a Ballast
                                Water record book and the taking of a certified
                                copy shall be performed as expeditiously as
                                possible without causing the ship to be unduly
                                delayed.
                            </p>
                        </li>
                    </ol>
                    {/* section */}
                    <div className="newpage">
                        <p className="font-bold mb-4">
                            <b>Regulation A-4 — Exemptions</b>
                        </p>
                        <ol className="ml-4 list-decimal marker:font-bold">
                            <li className="mb-8">
                                <p>
                                    A Party or Parties, in waters under their
                                    jurisdiction, may grant exemptions to any
                                    requirements to apply regulations B-3 or
                                    C-1, in addition to those exemptions
                                    contained elsewhere in this Convention, but
                                    only when they are:
                                </p>
                                <ol className="ml-8 list-decimal">
                                    <li className="mb-2">
                                        <p>
                                            granted to a ship or ships on a
                                            voyage or voyages between specified
                                            ports or locations; or to a ship
                                            which operates exclusively between
                                            specified ports or locations;
                                        </p>
                                    </li>
                                    <li className="mb-2">
                                        <p>
                                            effective for a period of no more
                                            than five years subject to
                                            intermediate review;
                                        </p>
                                    </li>
                                    <li className="mb-2">
                                        <p>
                                            granted to ships that do not mix
                                            Ballast Water or Sediments other
                                            than between the ports or locations
                                            specified in paragraph 1.1; and
                                        </p>
                                    </li>
                                    <li className="mb-2">
                                        <p>
                                            granted based on the Guidelines on
                                            risk assessment developed by the
                                            Organization.
                                        </p>
                                    </li>
                                </ol>
                            </li>
                            <li className="mb-8">
                                <p>
                                    Exemptions granted pursuant to paragraph 1
                                    shall not be effective until after
                                    communication to the Organization and
                                    circulation of relevant information to the
                                    Parties.
                                </p>
                            </li>
                            <li className="mb-8">
                                <p>
                                    Any exemptions granted under this regulation
                                    shall not impair or damage the environment,
                                    human health, property or resources of
                                    adjacent or other States. Any State that the
                                    Party determines may be adversely affected
                                    shall be consulted, with a view to resolving
                                    any identified concerns.
                                </p>
                            </li>
                            <li className="mb-8">
                                <p>
                                    Any exemptions granted under this regulation
                                    shall be recorded in the Ballast Water
                                    Record Book.
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            {/* Fifth Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="mb-8">
                    <h4 className="text-center font-bold mb-4 text-lg">
                        GENERAL INSTRUCTIONS
                    </h4>
                    <p className="mb-4">
                        Complete the diagram on page <strong>11</strong>. The
                        diagram is to identify the ballast tanks of the ship,
                        corresponding to the Ballast Water Management Plan,
                        including any multi-use tank, space or compartment
                        designed to allow carriage of ballast water.
                    </p>
                    <p className="mb-4">
                        Pages <strong>13-15</strong> contains the list of
                        ballast water operations which are, when appropriate, to
                        be recorded in the Ballast Water Record Book in
                        accordance with Regulations B-2. The items have been
                        grouped. into operational sections, each of which is
                        assigned with an appropriate Code (letter) and has a
                        list of items to be entered in the Ballast Water Record
                        Book.
                    </p>
                    <p className="mb-4">
                        The Ballast Water Record Book shall be maintained in the
                        English language.
                    </p>
                    <p className="mb-4">
                        Each entry shall be signed and dated by the officer in
                        charge of the operation concerned. Each completed page
                        shall be countersigned by the Master of the ship.
                    </p>
                    <p className="mb-4">
                        The volume of ballast water on board should be estimated
                        in cubic metres. It is recognized that the accuracy of
                        estimating volumes of ballast is left to interpretation.
                    </p>
                    <p className="mb-4">
                        Ships to which additional measures apply, under
                        Regulation C-1, should take them into account in the
                        ship’s voyage planning. Actions taken to comply with any
                        additional measures should be recorded in the Ballast
                        Water Record Book.
                    </p>
                    <p className="mb-4">
                        Where treated sewage and/or grey water is temporarily
                        stored in ballast water tanks in accordance with
                        BWM.2/Circ.82, the Ballast Water Record Book should have
                        an entry made under the appropriate code related to
                        additional operational procedures and general remarks
                        containing the details as mentioned in examples 22 and
                        23.
                    </p>
                    <p className="mb-4">
                        The Ballast Water Record Book shall be kept readily
                        available for inspection at all reasonable times and, in
                        the case of an unmanned ship under tow, may be kept on
                        the towing ship. (regulation B-2.4)
                    </p>
                    <h5 className="font-bold mb-4">
                        When to record operations in the Ballast Water Record
                        Book
                    </h5>

                    <ol className="ml-4 list-decimal marker:font-bold">
                        <li className="mb-8">
                            <p>
                                Each operation concerning Ballast Water shall be
                                fully recorded chronologically as per completion
                                without delay in the Ballast Water Record Book
                                (regulation B-2.5).
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                In the event of the discharge of ballast water
                                pursuant to regulations A-3 (exceptions), A-4
                                (exemptions), B-3.6 (ballast water discharged to
                                a reception facility) or B-3.7 (other methods of
                                ballast water management that are approved in
                                principle by the Committee) or in the event of
                                other accidental discharge/ingress or other
                                exceptional uptake or discharge of ballast water
                                not otherwise exempted by this Convention, an
                                entry shall be made in the Ballast Water Record
                                Book describing the circumstances of, and the
                                reason for, the discharge.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                If ballast water exchange is not undertaken for
                                the reasons in Regulation B-4, i.e. if the
                                master reasonably decides that such exchange
                                would threaten the safety or stability of the
                                ship, its crew, or its passengers because of
                                adverse weather, ship design or stress,
                                equipment failure, or any other extraordinary
                                condition, then details of the reasons ballast
                                water exchange was not undertaken are to be
                                recorded in the Ballast Water Record Book.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Record all failures or inoperabilities of the
                                ballast water management system in the Ballast
                                Water Record Book under Code F. If the failure
                                or inoperability is not immediately resolved, a
                                second Code F entry should later be recorded
                                when the BWMS is rectified and made operational.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Exemptions granted under regulation A-4 and any
                                additional measures under regulation C-1 shall
                                be recorded in the Ballast Water Record Book
                                under item Code H (regulation A-4.4). A page to
                                record exemptions is provided on page{' '}
                                <strong>12</strong>.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                For tankers, ballast taken into heavy weather
                                Cargo Oil Tanks is considered as exceptional
                                ballast as described in regulation 18.3 of
                                MARPOL Annex I and would be recorded in both the
                                Oil Record Book part II and in the Ballast Water
                                Record Book.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Ships should take the following guidance into
                                account in selecting code letters to reflect
                                ballasting operations:
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    <p>
                                        During a typical uptake or discharge
                                        operation, any ballast water treatment
                                        should be noted under Code A or Code B
                                        as appropriate. It is not necessary to
                                        enter Codes C1 or C2 to reflect this
                                        treatment.
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        A ballast water exchange operation
                                        should be entered using Code C1 (noting
                                        any ballast water treatment applied). It
                                        is not necessary to enter Codes A and B
                                        in conjunction with ballast water
                                        exchange.
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        Code C2 should be used when treatment
                                        occurs independently from an uptake or
                                        discharge (e.g. in-tank treatment, or
                                        treatment during circulation between
                                        tanks).
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        Ballast water internal transfer
                                        operations for the purpose of
                                        list/trim/stability of the ship
                                        involving similarly managed water should
                                        be recorded under Code H in the Ballast
                                        Water Record Book as the quantity in the
                                        tanks have changed.
                                    </p>
                                </li>
                            </ol>
                        </li>
                        <li className="mb-8">
                            <p>
                                The following guidance should be followed to
                                record any operation of temporarily storing
                                treated sewage and/or grey water (TS/GW) in
                                ballast water tanks in the Ballast Water Record
                                Book:
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    <p>
                                        The emptying of the ballast tank should
                                        be recorded as is normally done for
                                        deballasting operations under Code B.
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        The cleaning/flushing/disposal of
                                        sediments recorded under Code G.
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        The isolation of Ballast tank for
                                        purpose of storing TS/GW should be
                                        recorded under Code H.
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        The putting back into service of such
                                        tank for ballast purpose should also be
                                        recorded under Code H.
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        The flushing of the ballast tank again
                                        with treated water should be recorded
                                        under Code G.
                                    </p>
                                </li>
                            </ol>
                        </li>
                        <li className="mb-8">
                            <p>
                                Instances when the BWMS has not operated as
                                expected owing to challenging water quality and
                                may not be treating the water successfully
                                should be recorded in the BWRB. In this regard,
                                the ship’s BWRB should record the following
                                items:
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    <p>
                                        the reason why normal ballasting
                                        operations were stopped;
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        any steps taken to optimize the
                                        treatment process and resolve BWMS
                                        technical malfunctions;
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        the operational demands that were not
                                        met and/or operational limitations
                                        encountered;
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        the steps that were taken prior to a
                                        bypass being initiated (as relevant);
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        the tanks which have received bypassed
                                        ballast water (tank ID);
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        the date, time, location where the
                                        bypass took place; and
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        the flushing/decontamination steps that
                                        were taken to recover from BWMS bypass
                                        as per the approved BWMP, including: the
                                        start and end locations (GPS
                                        coordinates) at which any flushing took
                                        place, the start date and time; end date
                                        and time, and the volume flushed.
                                    </p>
                                </li>
                            </ol>
                            <p>
                                See Scenarios 4 and 5 under Example 27 for
                                further guidance.
                            </p>
                        </li>
                    </ol>

                    <h5 className="font-bold mb-4">
                        How to record operations in the Ballast Water Record
                        Book
                    </h5>

                    <ol className="ml-4 list-decimal marker:font-bold">
                        <li className="mb-8">
                            <p>
                                When making entries, write the date in
                                dd-MMM-yyyy format (e.g. 01-JUN-2022). If the
                                operations cross over the dates, then the entry
                                should be made after completion of the operation
                                and the start date can be mentioned as: - Start
                                1900 hrs (UTC) (hhmm SMT) on 01-JAN-2023 and
                                Completion at 0100 hrs (UTC) (hhmm SMT) on
                                02-JAN-2023.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Enter the appropriate code and item number in
                                the respective columns.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Enter all times using the Coordinated Universal
                                Time (UTC) and Ship's Mean Time (SMT).
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Record the ballast tank nomenclature as per the
                                diagram corresponding to the Ballast Water
                                Management Plan that forms a part of the Ballast
                                Water Record Book.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Enter the port names using the proper
                                standardized UN/LOCODE. If the UN/LOCODE is not
                                available, or an offshore terminal or anchorage
                                area is entered, write out Port Name and Country
                                in full. No abbreviation should be used.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Enter the location position in the degrees,
                                minutes and seconds format (example: Lat: 00
                                00.00 N/S, Long: 000 00.00 E/W).
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Under the item "Ballast water treatment method"
                                enter any treatment applied to the water during
                                the specific operation being recorded. No prior
                                treatment or intended future treatment should be
                                recorded. If more than one method applies (e.g.
                                partial treatment) then multiple entries should
                                be made, each pertaining to the relevant volume.
                                The following notations should be used:
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    <p>"Approved BWMS"</p>
                                </li>
                                <li className="mb-2">
                                    <p>"Prototype BWMS"; and</p>
                                </li>
                                <li className="mb-2">
                                    <p>
                                        "Regulation B-3.7", in the case of other
                                        methods of ballast water management
                                        approved in principle by the Committee
                                        in accordance with that regulation.
                                    </p>
                                </li>
                            </ol>
                        </li>

                        <li className="mb-8">
                            <p>
                                "None. (regulation A-4)", in the case of
                                exemptions granted in accordance with that
                                regulation.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                "None, as per BWMS design", in the case no
                                treatment is necessary during uptake or
                                discharge because of the design of the BWMS
                                (e.g. a BWMS that does not treat during
                                discharge, ora BWMS where the treatment takes
                                place in the tank).
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                "None. (regulation B-3)" if the ship is not yet
                                required to meet the standard in regulation D-2.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                "None" and specify the reason, in other cases
                                where no treatment is performed (e.g. BWMS
                                bypass).
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                There should not be blank lines between
                                successive entries.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                In the case of a ship subject to equivalent
                                compliance under regulation A-5 that is required
                                by its Administration to keep records of each
                                ballast water operation, the information
                                specified in this guidance should be taken into
                                account.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                The entries in the Ballast Water Record Book
                                shall be in the working language of the ship. If
                                that language is not English, French or Spanish,
                                the entries shall contain a translation into one
                                of those languages. When entries in an official
                                national language of the State whose flag the
                                ship is entitled to fly are also used, these
                                shall prevail in case of a dispute or
                                discrepancy. (regulation B-2.5)
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Each entry shall be signed by the officer in
                                charge of the operation concerned and each
                                completed page shall be signed by the master.
                                (regulation B-2.5)
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Incorrect entries should be struck through with
                                a single line in such a way that the wrong entry
                                is still legible. The incorrect entry should be
                                signed and dated and followed by the correct
                                entry.
                            </p>
                        </li>
                        <li className="mb-8">
                            <p>
                                Entries pertaining to an earlier missed
                                operation should be completed as per example 25.
                            </p>
                        </li>
                    </ol>
                </div>
            </div>
            {/* Sixth Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="w-full mb-8">
                    <div className="w-full">
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350 }}
                        >
                            <span className="uppercase">Name of Ship:</span>
                            <span className="p-0.5 m-0.5 border-b-2 border-gray-900 w-1/4">
                                {' '}
                                {vesselInfo?.vesselName}{' '}
                            </span>
                        </p>
                    </div>
                    <div className="w-full">
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350 }}
                        >
                            <span className="uppercase">IMO NUMBER:</span>
                            <span className="p-0.5 m-0.5 border-b-2 border-gray-900 w-1/4">
                                {' '}
                                {vesselInfo?.imoNumber}{' '}
                            </span>
                        </p>
                    </div>
                    <div className="w-full">
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350 }}
                        >
                            <span className="uppercase">
                                DISTINCTIVE NUMBER OR LETTERS:
                            </span>
                            <span className="p-0.5 m-0.5 border-b-2 border-gray-900 w-1/4">
                                {' '}
                                {vesselInfo?.distinctiveNumberOrLetters}{' '}
                            </span>
                        </p>
                    </div>
                </div>
                <div className="font-bold text-center mb-4">
                    <p className="text-lg">
                        Diagram identifying the ballast tanks of the ship
                    </p>
                    <p>(to be completed on board)</p>
                </div>
				<div className="flex items-center justify-center">
					{ballastData?.isDiagramOfShipIndicatingBallastTankAttached &&
						ballastData?.shipDiagramAttachment ? (
						<div className="w-1/2">
							<img
								style={{ maxWidth: '80%' }}
								src={
									ballastData?.shipDiagramAttachment.id
										? `${commonUtils.getAttachmentURL(
											ballastData?.shipDiagramAttachment
												.name,
											ballastData?.shipDiagramAttachment
												.id
										)}`
										: ''
								}
								alt="Ship diagram"
							/>
						</div>
					) : (
						<div
							className="flex justify-center"
							style={{
								width: '58%',
							}}
						>
							<img
								src={shipImg}
								style={{ height: 320 }}
								alt="ship"
							/>
						</div>
					)}
					<div
						className="flex justify-center"
						style={{
							width: '38%',
						}}
					>
						<div className="mt-10">{children}</div>
					</div>
				</div>
            </div>
            {/* Seventh Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="mb-8">
                    <h5 className="font-bold mb-4">Record of Exemptions</h5>
                    <p className="mb-4">
                        Exemptions granted under regulation A-4 shall be
                        recorded in the Ballast Water Record Book. Exemptions
                        may be recorded below.
                    </p>
                    <div>
                        <p className="mb-4">
                            Under regulation A-4, a Party or Parties to the
                            Ballast Water Convention, in waters under their
                            jurisdiction, may grant exemptions to any
                            requirements to apply regulations B-3 - Ballast
                            Water Management for Ships or C-1 - Additional
                            Measures, in addition to those exemptions contained
                            elsewhere in the Ballast Water Convention, but only
                            when they are:
                        </p>

                        <ol className="ml-8 list-decimal marker:font-bold">
                            <li className="mb-4">
                                <p>
                                    granted to a ship or ships on a voyage or
                                    voyages between specified ports or
                                    locations; or to a ship which operates
                                    exclusively between specified ports or
                                    locations;
                                </p>
                            </li>
                            <li className="mb-4">
                                <p>
                                    effective for a period of no more than five
                                    years subject to intermediate review;
                                </p>
                            </li>
                            <li className="mb-4">
                                <p>
                                    granted to ships that do not mix Ballast
                                    Water or Sediments other than between the
                                    ports or locations specified in paragraph
                                    1.1; and
                                </p>
                            </li>
                            <li className="mb-4">
                                <p>
                                    granted based on the Guidelines on risk
                                    assessment developed by the Organization.
                                </p>
                            </li>
                        </ol>
                    </div>
                    <h5 className="font-bold mb-4">Exemptions</h5>
                    <table className="w-full">
                        <colgroup>
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '75%' }} />
                        </colgroup>
                        <thead>
                            <tr className="h-8">
                                <th className="border border-gray-900 p-2">
                                    Date Issued (dd-MMM-yyyy)
                                </th>
                                <th className="border border-gray-900 p-2">
                                    Brief Summary or Attach Copy
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array(9)
                                .fill(null)
                                .map((_, index) => (
                                    <tr key={index} className="h-8">
                                        <td className="border border-gray-900 p-2"></td>
                                        <td className="border border-gray-900 p-2"></td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* Eighth Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="mb-8">
                    <h4 className="text-center font-bold mb-4 text-lg">
                        LIST OF ITEMS TO BE RECORDED
                    </h4>
                    <p className="mb-4">
                        Entries in the Ballast Water record book shall be made
                        on each of the following occasions:
                    </p>
                    <ol className="ml-4 list-alpha marker:font-bold">
                        <li className="mb-8">
                            <p className="font-bold">
                                When ballast water is taken on board from the
                                aquatic environment (ballasting operation)
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    Start time and location (port of uptake or
                                    latitude/longitude)
                                </li>
                                <li className="mb-2">
                                    Completion time and location (port of uptake
                                    or latitude/longitude and minimum depth of
                                    water during uptake)
                                </li>
                                <li className="mb-2">
                                    The identity of the tanks affected
                                </li>
                                <li className="mb-2">
                                    Estimated volume of uptake and final total
                                    quantity retained in cubic metres
                                </li>
                                <li className="mb-2">
                                    Whether conducted in accordance with the
                                    approved Ballast Water Management Plan
                                </li>
                                <li className="mb-2">
                                    Ballast water treatment method
                                </li>
                            </ol>
                        </li>
                        <li className="mb-8">
                            <p className="font-bold">
                                When ballast water is discharged into the
                                aquatic environment (deballasting operation)
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    Start time and location (port of discharge
                                    or latitude/longitude)
                                </li>
                                <li className="mb-2">
                                    Completion time and location (port of
                                    discharge or latitude/longitude and minimum
                                    depth of water during discharge)
                                </li>
                                <li className="mb-2">
                                    The identity of the tanks affected
                                </li>
                                <li className="mb-2">
                                    Estimated volume of discharge and final
                                    total quantity retained in cubic metres
                                </li>
                                <li className="mb-2">
                                    Whether conducted in accordance with the
                                    approved Ballast Water Management Plan
                                </li>
                                <li className="mb-2">
                                    Ballast water treatment method
                                </li>
                            </ol>
                        </li>
                        <li className="mb-8">
                            <p className="font-bold">
                                Whenever ballast water is exchanged, or treated
                                in-tank or treated through internal circulation
                            </p>
                            <ol className="list-decimal">
                                <li className="mb-2">
                                    <p className="font-bold">
                                        Ballast Water exchange
                                    </p>
                                    <ol className="ml-8 list-decimal">
                                        <li className="mb-2">
                                            Start time and location
                                            (latitude/longitude)
                                        </li>
                                        <li className="mb-2">
                                            Completion time and location
                                            (latitude/longitude)
                                        </li>
                                        <li className="mb-2">
                                            Minimum distance from the nearest
                                            land and minimum depth of water
                                            during the exchange or, if
                                            applicable, identify the designated
                                            exchange area in accordance with
                                            regulation B-4.2
                                        </li>
                                        <li className="mb-2">
                                            Whether conducted in accordance with
                                            the Ballast Water Management Plan
                                            and state the ballast water exchange
                                            method (sequential or flow-through
                                            or dilution) used
                                        </li>
                                        <li className="mb-2">
                                            The identity of the tanks affected
                                        </li>
                                        <li className="mb-2">
                                            Total quantity exchanged and final
                                            total quantity on board in cubic
                                            metres
                                        </li>
                                        <li className="mb-2">
                                            Treatment method for the incoming
                                            ballast water
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
            {/* Page Break */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="mb-8">
                    <ol className="list-decimal mb-8 ml-4" start={2}>
                        <li className="mb-2">
                            <p className="font-bold">
                                Ballast water internal circulation for treatment
                                or in-tank treatment
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">Start time</li>
                                <li className="mb-2">Completion time</li>
                                <li className="mb-2">
                                    The identity of the tanks affected
                                    (identifying source and destination tanks if
                                    applicable)
                                </li>
                                <li className="mb-2">
                                    Total quantity treated (through circulation
                                    or in tank) in cubic metres
                                </li>
                                <li className="mb-2">
                                    Ballast water treatment method
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <ol className="ml-4 list-alpha marker:font-bold" start={4}>
                        <li className="mb-8">
                            <p className="font-bold">
                                Uptake or discharge of ballast water from/to a
                                port-based or reception facility
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    Start time and location of uptake/discharge
                                    (state facility name)
                                </li>
                                <li className="mb-2">Completion time</li>
                                <li className="mb-2">
                                    Operation carried out (whether uptake or
                                    discharge)
                                </li>
                                <li className="mb-2">
                                    The identity of the tanks affected
                                </li>
                                <li className="mb-2">
                                    Total quantity in cubic metres and final
                                    quantity retained on board
                                </li>
                                <li className="mb-2">
                                    Whether conducted in accordance with the
                                    approved Ballast Water Management Plan
                                </li>
                                <li className="mb-2">
                                    Onboard ballast water treatment method
                                </li>
                            </ol>
                        </li>
                        <li className="mb-8">
                            <p className="font-bold">
                                Accidental discharge/ingress or other
                                exceptional uptake or discharge of ballast water
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    Start time and location of
                                    ingress/uptake/discharge (port name or
                                    latitude/longitude)
                                </li>
                                <li className="mb-2">Completion time</li>
                                <li className="mb-2">
                                    Operation carried out (whether ingress,
                                    uptake or discharge)
                                </li>
                                <li className="mb-2">
                                    The identity of the tanks affected
                                </li>
                                <li className="mb-2">
                                    Total quantity of ballast water in cubic
                                    metres
                                </li>
                                <li className="mb-2">
                                    State the circumstances of ingress, uptake,
                                    discharge or loss, the reason thereof, any
                                    treatment method used and general remarks
                                </li>
                            </ol>
                        </li>
                        <li className="mb-8">
                            <p className="font-bold">
                                Failures and inoperabilities* of the ballast
                                water management system
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    Time and location (port name or
                                    latitude/longitude) of failure of the
                                    ballast water management system
                                </li>
                                <li className="mb-2">
                                    Operation carried out (state whether uptake
                                    or discharge)
                                </li>
                                <li className="mb-2">
                                    Description of the issue (e.g. kind of alarm
                                    or other description of circumstances)
                                </li>
                                <li className="mb-2">
                                    Time and location (port name or
                                    latitude/longitude) when the ballast water
                                    management system has been made operational
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <div
                        className="border-[#2D3748] border-[0.5px] mt-8 mb-3 mx-0"
                        style={{ width: 224 }}
                    />
                    <div>
                        <div className="flex items-start mx-0 my-2">
                            <span className="text-sm">
                                * Failures and inoperabilities include
                                malfunctions, shutdowns or critical alarms
                                indicating a failure of the ballast water
                                management system which may indicate
                                non-compliance with the D-2 standard (except
                                routine information and warnings).
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {/* Page Break */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="mb-8">
                    <ol className="ml-4 list-alpha marker:font-bold" start={7}>
                        <li className="mb-8">
                            <p className="font-bold">
                                Ballast tank cleaning/flushing, removal and
                                disposal of sediments
                            </p>
                            <ol className="ml-8 list-decimal">
                                <li className="mb-2">
                                    Time and ship's location on commencement of
                                    ballast tank cleaning/flushing, removal or
                                    disposal of sediments (port name or
                                    latitude/longitude)
                                </li>
                                <li className="mb-2">
                                    Time and ship's location on completion of
                                    ballast tank cleaning/flushing, removal or
                                    disposal of sediments (port name or
                                    latitude/longitude)
                                </li>
                                <li className="mb-2">
                                    Tank(s) identification (name of the ballast
                                    tanks as per the Ballast Water Management
                                    Plan)
                                </li>
                                <li className="mb-2">
                                    Discharge or disposal to a reception
                                    facility (state quantity in cubic metres and
                                    name of the facility)
                                </li>
                                <li className="mb-2">
                                    Disposal or discharge to the aquatic
                                    environment as per Ballast Water Management
                                    Plan (state quantity in cubic metres,
                                    minimum distance from the nearest land in nm
                                    and minimum depth of water in metres)
                                </li>
                            </ol>
                        </li>
                        <li className="mb-8">
                            <p className="font-bold">
                                Additional operational procedures and general
                                remarks
                            </p>
                            <p>
                                If additional measures apply to the ship, under
                                Regulation C-1, and are taken into account in
                                the ship’s voyage planning, the actions taken to
                                comply with these additional measures should be
                                recorded.
                            </p>
                        </li>
                    </ol>
                </div>
            </div>
            {/* Ninth Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2 text-left newpage">
                <div className="w-full mb-8">
                    <h4 className="font-bold mb-4 text-lg">
                        RECORD OF BALLAST WATER OPERATIONS
                    </h4>
                    <div className="w-full">
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350 }}
                        >
                            <span className="uppercase">Name of Ship:</span>
                            <span className="p-0.5 m-0.5 border-b-2 border-gray-900 w-1/4">
                                {' '}
                                {vesselInfo?.vesselName}{' '}
                            </span>
                        </p>
                    </div>
                    <div className="w-full">
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350 }}
                        >
                            <span className="uppercase">IMO NUMBER:</span>
                            <span className="p-0.5 m-0.5 border-b-2 border-gray-900 w-1/4">
                                {' '}
                                {vesselInfo?.imoNumber}{' '}
                            </span>
                        </p>
                    </div>
                    <div className="w-full">
                        <p
                            className="p-0.5 m-0.5 flex items-center"
                            style={{ minWidth: 350 }}
                        >
                            <span className="uppercase">
                                DISTINCTIVE NUMBER OR LETTERS:
                            </span>
                            <span className="p-0.5 m-0.5 border-b-2 border-gray-900 w-1/4">
                                {' '}
                                {vesselInfo?.distinctiveNumberOrLetters}{' '}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const marpolStore = marpolSelectors._getStore(store);
    const totalBallastTanksCapacity = parseFloat(
        marpolSelectors.getBallastTanksTotalCapcity(marpolStore)
    );
    const inspectorStore = inspectorSelectors._getStore(store);
    const dateRange = inspectorSelectors.getDateRange(inspectorStore);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);

    let ballastData = vesselSelectors.getBallastData(vesselStore);
    ballastData = {
        ...ballastData,
        totalBallastWaterCapacity: ballastData.totalBallastWaterCapacity
            ? ballastData.totalBallastWaterCapacity
            : totalBallastTanksCapacity,
    };

    return {
        vesselInfo,
        ballastData,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BallastCoverPage);
